import { render, staticRenderFns } from "./automatic_marking.vue?vue&type=template&id=5ed2e76c&scoped=true"
import script from "./automatic_marking.vue?vue&type=script&lang=js"
export * from "./automatic_marking.vue?vue&type=script&lang=js"
import style0 from "./automatic_marking.vue?vue&type=style&index=0&id=5ed2e76c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed2e76c",
  null
  
)

export default component.exports